import React from 'react';
import { useTranslation } from 'react-i18next';
import { SendWarning } from '../../utils/sendChecks';

// Pre-send reminder shared by both composers (see utils/sendChecks). Same look as the composers'
// confirm dialog; "Go back" is the default button, "Send anyway" sends the email as it is.
export default function SendCheckModal({ warnings, onBack, onSendAnyway }: {
  warnings: SendWarning[];
  onBack: () => void;
  onSendAnyway: () => void;
}) {
  const { t } = useTranslation();
  return (
    <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.4)', zIndex: 4000, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <div style={{ background: 'var(--bg-surface)', border: '1px solid var(--border)', borderRadius: 'var(--radius-xl)', boxShadow: 'var(--shadow-md)', padding: '24px 28px', width: 360, textAlign: 'center' }}>
        <i className="ti ti-alert-triangle" style={{ fontSize: 32, color: '#BA7517', marginBottom: 12, display: 'block' }} aria-hidden />
        <div style={{ display: 'flex', flexDirection: 'column', gap: 10, marginBottom: 20 }}>
          {warnings.map(w => (
            <p key={w.kind} style={{ fontSize: 14, color: 'var(--text-primary)', lineHeight: 1.5 }}>
              {w.kind === 'no_subject' ? t('eml_sendcheck_no_subject') : t('eml_sendcheck_no_attachment', { word: w.word })}
            </p>
          ))}
        </div>
        <div style={{ display: 'flex', gap: 10, justifyContent: 'center' }}>
          <button onClick={onBack} autoFocus style={{ padding: '8px 20px', fontSize: 13, borderRadius: 'var(--radius-md)', border: 'none', background: 'var(--accent)', color: '#fff', cursor: 'pointer', fontWeight: 600 }}>{t('eml_sendcheck_back')}</button>
          <button onClick={onSendAnyway} style={{ padding: '8px 20px', fontSize: 13, borderRadius: 'var(--radius-md)', border: '1px solid var(--border)', background: 'transparent', color: 'var(--text-secondary)', cursor: 'pointer' }}>{t('eml_sendcheck_send_anyway')}</button>
        </div>
      </div>
    </div>
  );
}
